import React, { useState } from 'react'
import AgeLimitPopup from '@/components/shared/livemallclub/AgeLimitPopup'

const useAgeLimitPopup = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const PopupComponent = () => {
    return <AgeLimitPopup isOpen={isOpen} handleClose={handleClose} />
  }

  return { PopupComponent, handleOpen, handleClose }
}

export default useAgeLimitPopup
